/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrebidDto } from '../../models/prebid-dto';

export interface GetBidderLotPrebids$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getBidderLotPrebids(http: HttpClient, rootUrl: string, params: GetBidderLotPrebids$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrebidDto>>> {
  const rb = new RequestBuilder(rootUrl, getBidderLotPrebids.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PrebidDto>>;
    })
  );
}

getBidderLotPrebids.PATH = '/api/prebids/{id}/bidder-lot-prebids';
